module.exports = __webpack_public_path__ + "static/media/jin.f34b9912.png";